export function getArticleSchemas(article: {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  author: string;
  imageUrl: string;
}) {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: article.title,
      description: article.excerpt,
      image: article.imageUrl,
      author: {
        '@type': 'Organization',
        name: article.author,
      },
      publisher: {
        '@type': 'Organization',
        name: '2pg·com',
        logo: {
          '@type': 'ImageObject',
          url: 'https://2pg.com/logo.png',
        },
      },
      datePublished: article.date,
      url: `https://2pg.com/article/${article.id}`,
      isPartOf: {
        '@type': 'WebSite',
        name: '2pg·com',
        url: 'https://2pg.com',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: `${article.title} | 2pg·com 攻略资讯`,
      url: `https://2pg.com/article/${article.id}`,
      description: article.excerpt,
      isPartOf: {
        '@type': 'WebSite',
        name: '2pg·com',
        url: 'https://2pg.com',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://2pg.com',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '攻略资讯',
          item: 'https://2pg.com/articles',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: article.title,
          item: `https://2pg.com/article/${article.id}`,
        },
      ],
    },
  ];
}